export class UserProfileImageResultDto {
  imageBase64: string;
}
